// Updated HomeEquipo.js with MUI Grid for responsive layout
import React, { useContext, useState } from "react";
import { Grid } from "@mui/material";
import perfilDefault from "../../images/user.png";
import { ModalVistaTrabajador } from "../ModalVistaTrabajador";

const HomeEquipo = ({ infoCompany }) => {
	const API_URL = process.env.REACT_APP_API_URL;
	const workers = infoCompany?.workers??[];
	const [openModal, setOpenModal] = useState(false);
	const [selectedWorker, setSelectedWorker] = useState(null);

	const handleOpenWorker = (worker) => {
		setSelectedWorker(worker);
		setOpenModal(true);
	};

	// Clases de estilo por tarjeta
	const cardClasses = [
		"team-green",
		"team-piel txt-black",
		"team-yellow-dark txt-black",
		"team-blue",
		"team-green-dark",
		"team-yellow txt-black",
	];

	return (
		<div className="team-company">
			<div className="team-title">
				<hr className="line" style={{ background: 'var(--theme-visit)' }} />
				<h2>
					NUESTRO EQUIPO DE <span style={{ color: 'var(--theme-visit)' }}>TRABAJO</span>
				</h2>
				<hr className="line" style={{ background: 'var(--theme-visit)' }} />
			</div>

			<div style={{ width: "100%", maxWidth: "1200px", margin: "0 auto", padding: "0 1rem" }}>
				<Grid container spacing={{ xs: 2, sm: 3, md: 4 }}>
					{workers.map((worker, index) => {
						const cardClass = cardClasses[index % cardClasses.length];
						const imgUrl = worker.profile ? `${API_URL}${worker.profile}` : perfilDefault;

						return (
							<Grid item xs={6} sm={6} md={4} lg={4} key={index}>
								<div
									className={`card-team ${cardClass}`}
									onClick={() => handleOpenWorker(worker)}
									style={{
										cursor: "pointer",
										height: "100%", // Ensure the card takes full height of the grid cell
										width: "100%", // Ensure the card takes full width
										margin: 0, // Remove any default margin
									}}>
									<div className="section-team">
										<h2>
											{worker.job?.split(",")[0] || "Cargo"}
											<br />
											<strong>{worker.job?.split(",")[1] || ""}</strong>
										</h2>
									</div>
									<div className="section-team team-img">
										<img src={imgUrl} alt={worker.fullName} />
									</div>
									<div className="section-team">
										<h3>{worker.fullName}</h3>
									</div>
									<div className="glow-wrap">
										<i className="glow"></i>
									</div>
								</div>
							</Grid>
						);
					})}
				</Grid>
			</div>

			<ModalVistaTrabajador open={openModal} onClose={() => setOpenModal(false)} trabajador={selectedWorker} />
		</div>
	);
};

export default HomeEquipo;
